<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:58
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-08 20:10:55
-->
<template>
  <div class="bottom-center">
    <div class="bottomLeft">
      <cockpit-title title="应用总流量趋势" enTitle="yyzllqs" />
      <div class="left">
        <BottomLeft></BottomLeft>
      </div>
    </div>
    <div class="bottomCenter">
      <cockpit-title title="丽水市流量占比" enTitle="lssllzb" />
      <div class="center">
        <BottomCenter></BottomCenter>
      </div>
    </div>
    <div class="bottomBottom">
      <cockpit-title title="活跃用户占比" enTitle="hyyhzb" />
      <div class="bottom">
        <BottomRight></BottomRight>
      </div>
    </div>
  </div>
</template>

<script>
import cockpitTitle from '../cockpit-title.vue'
import BottomLeft from './bottomLeft.vue'
import BottomCenter from './bottomCenter.vue'
import BottomRight from './bottomRight.vue'
export default {
  name: 'Right',
  components: { cockpitTitle, BottomLeft, BottomCenter, BottomRight }
}
</script>

<style lang="scss" scoped>
.bottom {
  &-center {
    display: flex;
    height: 100%;
    > div {
      flex: 1;
      width: 31%;
      height: 250px;
      margin: 0 5px;
      overflow: hidden;
    }

    .bottomCenter,
    .bottomLeft,
    .bottomBottom {
      width: 100%;
      height: 100%;
    }
    .left,
    .center,
    .bottom {
      width: 100%;
      height: calc(100% - 20px);
    }
  }
}
</style>
